<script>
  import fontMod from '../fonts'

  const fonts = fontMod()

  export let fontType
  let fontUrl

  $: if (fontType) {
    fontUrl = fonts[fontType]
  }
</script>

<svelte:head>
  {#if fontUrl}
    <link href={fontUrl} rel="stylesheet" />
  {/if}
</svelte:head>
